module.exports = __webpack_public_path__ + "static/img/sl.be34dbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sl.png
// module id = IIwu
// module chunks = 0